import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  invoiceItemsTable,
  salesOrderItemsTable,
} from "../../../config/grid-column-defs";
import { getTransactionItems } from "../../../api/transaction-type";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, FormControlLabel, FormGroup, Grid } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { GridComp12, GridComp126 } from "../../../components/GridComponents";
import { CustomCheckBoxComp126 } from "../../../components/CheckboxComp";
import {
  getTransactionInvoiceDetail,
  getTransactionInvoiceItemDetail,
} from "../../../api/invoice";

export default function InvoiceItems({setSum,rowData}) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];
  // const [rowData, setRowData] = useState({});

  async function getTransactionItemsData(limit=10, offset=0) {
    setLoading(true);
    try {
      const { data } = await getTransactionInvoiceItemDetail(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      // setRowData(data.data);
      setSum(data?.data?.itemsum)
      setLoading(false);
      return {
        rows: data.data.items,
        total: data.data.itemstotal,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Box className="viewDetilsBox" style={{ height: "auto" }}>
        <Grid container className="mb-2">
          <GridComp12 title={"DISCOUNT ITEM"} data={rowData[0]?.discount_item} />
          <GridComp12 title={"RATE"} data={rowData[0]?.rate} />
           {rowData[0]?.taxoverride === "F" ||
                      rowData[0]?.taxoverride === "" ? (
                        <Grid item xs={12} sm={4} md={4} className="m-b-10">
                          <p className="tFormlabel">
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox  disabled/>}
                                label="TAX OVERRIDE"
                              />
                            </FormGroup>
                          </p>
                        </Grid>
                      ) : (
                        <Grid item xs={12}sm={4} md={4} className="m-b-10">
                          <p className="tFormlabel">
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox checked disabled/>}
                                label="TAX OVERRIDE"
                              />
                            </FormGroup>
                          </p>
                        </Grid>
                      )}
          {/* <CustomCheckBoxComp126
            title={"TAX DATE OVERRIDE"}
            data={rowData[0]?.tax_date_override}
          />
          <GridComp126
            title={"AVATAX OVERRIDE DATE"}
            data={rowData?.avatax_override_date}
          /> */}
        </Grid>
        <Box
      sx={{
        width: '100%',
        overflowX: 'auto',
        padding: 2, 
        boxSizing: 'border-box', 
        '@media (max-width:600px)': {
          padding: 1,
        },
      }}
    >
      <AgGridPaginatedTable
        getTableRows={getTransactionItemsData}
        columns={invoiceItemsTable}
        perPage={10}
        refreshCounter={0}
      />
    </Box>
      </Box>
    </>
  );
}
